import { FC, ReactNode } from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Stack } from '@mui/material';

type Tone = 'warning' | 'info';

const TONES: Record<Tone, { bg: string; border: string; color: string }> = {
  warning: { bg: '#FFFBEB', border: '#FDE68A', color: '#B45309' },
  info: { bg: 'brand.lightest', border: '#CCEDFF', color: 'brand.darkest' },
};

/**
 * The inline explanation shown when a pass exists but cannot be redeemed here
 * and now — a failed renewal, a station outside the pass's scope, or a cycle
 * with no swaps left.
 */
export const PassNoticeBanner: FC<{
  children: ReactNode;
  tone?: Tone;
  action?: ReactNode;
}> = ({ children, tone = 'warning', action }) => {
  const palette = TONES[tone];

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      gap={1.5}
      sx={{
        width: '100%',
        bgcolor: palette.bg,
        border: `1px solid ${palette.border}`,
        borderRadius: 1.5,
        px: 2,
        py: 1.5,
        color: palette.color,
        textAlign: 'left',
      }}
    >
      <WarningAmberRoundedIcon sx={{ fontSize: 24, flexShrink: 0 }} />
      <Stack gap={1} flex={1}>
        {children}
        {action}
      </Stack>
    </Stack>
  );
};
